import { render, staticRenderFns } from "./LoginCommon.vue?vue&type=template&id=0936e5d7&scoped=true"
import script from "./LoginCommon.vue?vue&type=script&lang=js"
export * from "./LoginCommon.vue?vue&type=script&lang=js"
import style0 from "./LoginCommon.vue?vue&type=style&index=0&id=0936e5d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0936e5d7",
  null
  
)

export default component.exports